import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function OrganizationManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'add'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    orgName: '',
    businessType: '',
    country: '',
    website: '',
    address: '',
    contactName: '',
    phone: '',
    mobile: '',
    email: '',
    authName: '',
    authDesignation: '',
    authEmail: '',
    authPhone: '',
    bankName: '',
    branchName: '',
    accountName: '',
    accountNumber: '',
    routingNumber: '',
    legalDocs: ''
  });
  const [organizations, setOrganizations] = useState([{
    orgName: 'Sundarban Fisheries Ltd',
    email: 'info@sundarbanfish.com',
    idNumber: 'ORG-001',
    phone: '01711001122',
    businessType: 'Fisheries',
    status: 'approved' as const
  }, {
    orgName: 'Bay of Bengal Trading Co.',
    email: 'contact@bobtrade.com',
    idNumber: 'ORG-002',
    phone: '01811223344',
    businessType: 'Trading',
    status: 'approved' as const
  }, {
    orgName: 'Khulna Honey Producers',
    email: 'khp@gmail.com',
    idNumber: 'ORG-003',
    phone: '01911334455',
    businessType: 'Honey Production',
    status: 'approved' as const
  }, {
    orgName: 'Mongla Port Services',
    email: 'mps@mongla.com',
    idNumber: 'ORG-004',
    phone: '01611445566',
    businessType: 'Port Services',
    status: 'pending' as const
  }, {
    orgName: 'Satkhira Wood Industries',
    email: 'swi@satkhira.com',
    idNumber: 'ORG-005',
    phone: '01511556677',
    businessType: 'Wood Processing',
    status: 'approved' as const
  }]);
  const columns = [{
    key: 'orgName',
    label: 'Organization Name'
  }, {
    key: 'email',
    label: 'Email ID'
  }, {
    key: 'idNumber',
    label: 'ID Number'
  }, {
    key: 'phone',
    label: 'Phone Number'
  }, {
    key: 'businessType',
    label: 'Business Type'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-1792" data-mp="1b4ok7d7zcmq" />
  }];
  const filters = [{
    key: 'businessType',
    label: 'Business Type',
    options: ['Fisheries', 'Trading', 'Honey Production', 'Port Services', 'Wood Processing']
  }, {
    key: 'status',
    label: 'Status',
    options: ['Approved', 'Pending', 'Rejected']
  }];
  const wizardSteps = [{
    title: 'Organization Info',
    description: 'Enter basic organization details'
  }, {
    title: 'Contact Info',
    description: 'Enter contact and authorized person details'
  }, {
    title: 'Bank Details',
    description: 'Enter banking information'
  }, {
    title: 'Documents',
    description: 'Upload legal documents'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-1793" data-mp="22yl9eq6gkfpt">
      <div data-id="element-1794" data-mp="27w3hyfgkcsxa">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1795" data-mp="27vto2gsee1mb">
          Organization Management
        </h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-1796" data-mp="2vl5xnhrn0bp5">
          Manage registered organizations and companies
        </p>
      </div>

      <div className="border-b border-gray-200" data-id="element-1797" data-mp="2zlzmcdcwluj3">
        <div className="flex gap-4" data-id="element-1798" data-mp="2lvw3lwd8giye">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1799" data-mp="2lutglzj170nr">
            Organization List
          </button>
          <button onClick={() => setActiveTab('add')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'add' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1800" data-mp="3jcl3vlmjbd5o">
            Add Organization
          </button>
        </div>
      </div>

      {activeTab === 'list' && <DataTable columns={columns} data={organizations} filters={filters} onDataChange={setOrganizations} searchPlaceholder="Search organizations..." data-id="element-1801" data-mp="1gr907d77vhqq" />}

      {activeTab === 'add' && <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.orgName || !formData.businessType) {
        alert('Please fill in all required fields.');
        return;
      }
      alert(`Organization ${formData.orgName} registered successfully!`);
      setCurrentStep(0);
      setActiveTab('list');
      setFormData({
        orgName: '',
        businessType: '',
        country: '',
        website: '',
        address: '',
        contactName: '',
        phone: '',
        mobile: '',
        email: '',
        authName: '',
        authDesignation: '',
        authEmail: '',
        authPhone: '',
        bankName: '',
        branchName: '',
        accountName: '',
        accountNumber: '',
        routingNumber: '',
        legalDocs: ''
      });
    }} data-id="element-1802" data-mp="24nd9gg8xfk1l">
          {currentStep === 0 && <div className="space-y-4" data-id="element-1803" data-mp="178bfszmgo9l">
              <div className="grid grid-cols-2 gap-4" data-id="element-1804" data-mp="166x9fnb7lnn">
                <div data-id="element-1805" data-mp="58tvpzehk4tt">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1806" data-mp="59d70x9mruyv">
                    Organization Name *
                  </label>
                  <input type="text" required value={formData.orgName} onChange={e => setFormData({
              ...formData,
              orgName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1807" data-mp="a52a3akuztzx" />
                </div>
                <div data-id="element-1808" data-mp="2kzpjuuoawgwh">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1809" data-mp="2l08v5sjg471j">
                    Business Type *
                  </label>
                  <select required value={formData.businessType} onChange={e => setFormData({
              ...formData,
              businessType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1810" data-mp="2yx4dkbll7au9">
                    <option value="" data-id="element-1811" data-mp="3g782kqcu3avs">Select Type</option>
                    <option value="Fisheries" data-id="element-1812" data-mp="32he8ntmh20f7">Fisheries</option>
                    <option value="Trading" data-id="element-1813" data-mp="32f1w5vzhgi9j">Trading</option>
                    <option value="Honey Production" data-id="element-1814" data-mp="36hoglbttr0wp">Honey Production</option>
                    <option value="Port Services" data-id="element-1815" data-mp="2sifchaiw7x93">Port Services</option>
                    <option value="Wood Processing" data-id="element-1816" data-mp="2slb8uuf3edvf">Wood Processing</option>
                    <option value="Other" data-id="element-1817" data-mp="2xjct3io98j8h">Other</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1818" data-mp="2jkmx66d68plp">
                <div data-id="element-1819" data-mp="2nkn99kcssopl">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1820" data-mp="2nk5eyt9p4kkb">
                    Business Operation Country
                  </label>
                  <input type="text" value={formData.country} onChange={e => setFormData({
              ...formData,
              country: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1821" data-mp="lssc09ragmqw" />
                </div>
                <div data-id="element-1822" data-mp="2mxs3l21aj5f4">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1823" data-mp="2mz39b7eaqn8v">
                    Website
                  </label>
                  <input type="url" value={formData.website} onChange={e => setFormData({
              ...formData,
              website: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1824" data-mp="2i11rsqwiqvzi" />
                </div>
              </div>
              <div data-id="element-1825" data-mp="eoc7p355j37c">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1826" data-mp="is0gtq9fm6up">
                  Communication Address
                </label>
                <textarea rows={3} value={formData.address} onChange={e => setFormData({
            ...formData,
            address: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1827" data-mp="nk1qd4f7tjh1" />
              </div>
            </div>}

          {currentStep === 1 && <div className="space-y-6" data-id="element-1828" data-mp="9sn3gmi6sy4p">
              <div data-id="element-1829" data-mp="1g7xjy09hmv9l">
                <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1830" data-mp="1g6cpsbr35ec9">
                  Primary Contact
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-1831" data-mp="1l4nyuk9k3ktf">
                  <div data-id="element-1832" data-mp="1kjh276f7729j">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1833" data-mp="1khw81hwsplc7">
                      Contact Person Name
                    </label>
                    <input type="text" value={formData.contactName} onChange={e => setFormData({
                ...formData,
                contactName: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1834" data-mp="1u8qv2ohv8oyp" />
                  </div>
                  <div data-id="element-1835" data-mp="1fjuoywzddm0q">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1836" data-mp="1fkdutfbqwjye">
                      Email
                    </label>
                    <input type="email" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1837" data-mp="2m213s06fk9ul" />
                  </div>
                  <div data-id="element-1838" data-mp="2ic6ysnb1agxm">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1839" data-mp="2icgpkd3wks4d">
                      Phone
                    </label>
                    <input type="tel" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1840" data-mp="2dbsmgt2egkts" />
                  </div>
                  <div data-id="element-1841" data-mp="1w2gkh0qopa6x">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1842" data-mp="20uhx4nrrl2xh">
                      Mobile
                    </label>
                    <input type="tel" value={formData.mobile} onChange={e => setFormData({
                ...formData,
                mobile: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1843" data-mp="1n44nmgz85g61" />
                  </div>
                </div>
              </div>

              <div className="pt-4 border-t border-gray-200" data-id="element-1844" data-mp="2auikqlwo257h">
                <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1845" data-mp="udmjrdqofark">
                  Authorized Person
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-1846" data-mp="zbfumk2xcsy6">
                  <div data-id="element-1847" data-mp="qvgpu5wb3637">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1848" data-mp="quoxr51x3qho">
                      Authorized Person Name
                    </label>
                    <input type="text" value={formData.authName} onChange={e => setFormData({
                ...formData,
                authName: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1849" data-mp="10uxwoqnanq0r" />
                  </div>
                  <div data-id="element-1850" data-mp="d428e3i1rcy9">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1851" data-mp="d3shmdp6h1ri">
                      Designation
                    </label>
                    <input type="text" value={formData.authDesignation} onChange={e => setFormData({
                ...formData,
                authDesignation: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1852" data-mp="3gm3pz4dbg21m" />
                  </div>
                  <div data-id="element-1853" data-mp="32jve4uyhmyv3">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1854" data-mp="32komg0d3hwfc">
                      Authorized Email
                    </label>
                    <input type="email" value={formData.authEmail} onChange={e => setFormData({
                ...formData,
                authEmail: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1855" data-mp="3cikxks618rdg" />
                  </div>
                  <div data-id="element-1856" data-mp="19w78sej9tcwq">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1857" data-mp="19uw4mdlwy353">
                      Authorized Phone/Mobile
                    </label>
                    <input type="tel" value={formData.authPhone} onChange={e => setFormData({
                ...formData,
                authPhone: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1858" data-mp="10wamuko9ms5d" />
                  </div>
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4" data-id="element-1859" data-mp="8621yl2chtn3">
              <div className="grid grid-cols-2 gap-4" data-id="element-1860" data-mp="896gab9iy5rh">
                <div data-id="element-1861" data-mp="9paf77deoplk">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1862" data-mp="9os9zl8rn11i">
                    Bank Name
                  </label>
                  <input type="text" value={formData.bankName} onChange={e => setFormData({
              ...formData,
              bankName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1863" data-mp="nkok3rcluou" />
                </div>
                <div data-id="element-1864" data-mp="3d34tifnqha79">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1865" data-mp="3i3sqdhyn8l9e">
                    Branch Name
                  </label>
                  <input type="text" value={formData.branchName} onChange={e => setFormData({
              ...formData,
              branchName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1866" data-mp="344t4uj6fgmhg" />
                </div>
                <div data-id="element-1867" data-mp="2ufvytfsgy3hd">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1868" data-mp="2ufdtltntwexb">
                    Account Name
                  </label>
                  <input type="text" value={formData.accountName} onChange={e => setFormData({
              ...formData,
              accountName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1869" data-mp="33hn5amuu2eca" />
                </div>
                <div data-id="element-1870" data-mp="xf6e1i1ca6is">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1871" data-mp="xfpko2ljh8hi">
                    Account Number
                  </label>
                  <input type="text" value={formData.accountNumber} onChange={e => setFormData({
              ...formData,
              accountNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1872" data-mp="12g3wlvq9h2kt" />
                </div>
                <div data-id="element-1873" data-mp="nn0cbglacaqe">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1874" data-mp="sftim8wejr4l">
                    Routing Number
                  </label>
                  <input type="text" value={formData.routingNumber} onChange={e => setFormData({
              ...formData,
              routingNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1875" data-mp="3r4s8762jletv" />
                </div>
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-4" data-id="element-1876" data-mp="35mt4g4ylpuk5">
              <div data-id="element-1877" data-mp="35nufi9fmah1v">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1878" data-mp="35ocn227qchp3">
                  Legal Documents *
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1879" data-mp="2vvyjr510730t" />
                <p className="text-xs text-gray-500 mt-1" data-id="element-1880" data-mp="2mxutjvf2pi2o">
                  Upload Trade License, TIN, BIN, etc. (PDF or Image)
                </p>
              </div>
            </div>}

          {currentStep === 4 && <div className="space-y-6" data-id="element-1881" data-mp="12rdpnn8tusa8">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1882" data-mp="12sow5utnqe51">
                <div className="flex items-center justify-between mb-3" data-id="element-1883" data-mp="xs173eozo7dg">
                  <h4 className="font-semibold text-gray-900" data-id="element-1884" data-mp="stpw30myjqtn">
                    Organization Information
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1885" data-mp="nuwg91k77nqb">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1886" data-mp="f08ehldu0o69">
                  <div data-id="element-1887" data-mp="a4b0hlq1jtwn">
                    <span className="text-gray-600" data-id="element-1888" data-mp="a52rskclv5h4">Name:</span>{' '}
                    <span className="font-medium" data-id="element-1889" data-mp="533pzewikgma">
                      {formData.orgName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1890" data-mp="3m6jb6mt4obf2">
                    <span className="text-gray-600" data-id="element-1891" data-mp="3m7ax15wxaus5">Business Type:</span>{' '}
                    <span className="font-medium" data-id="element-1892" data-mp="3r5cexnim4o21">
                      {formData.businessType || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1893" data-mp="2t881nivy8">
                    <span className="text-gray-600" data-id="element-1894" data-mp="4ye4mn7lheik">Country:</span>{' '}
                    <span className="font-medium" data-id="element-1895" data-mp="4xmj657pox60">
                      {formData.country || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1896" data-mp="38fearihxrf3o">
                <div className="flex items-center justify-between mb-3" data-id="element-1897" data-mp="3ddxy9nc6gyy5">
                  <h4 className="font-semibold text-gray-900" data-id="element-1898" data-mp="3i4o0wst7ynp5">Contact Info</h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1899" data-mp="3i6r125o35x7l">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1900" data-mp="2hn5qb9uz9n9g">
                  <div data-id="element-1901" data-mp="2couc6mxngqlf">
                    <span className="text-gray-600" data-id="element-1902" data-mp="2cpm9q3at4yec">Contact Person:</span>{' '}
                    <span className="font-medium" data-id="element-1903" data-mp="2rdh3zo4gratj">
                      {formData.contactName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1904" data-mp="2mffiyxnh91ff">
                    <span className="text-gray-600" data-id="element-1905" data-mp="1yp35765jwagx">Email:</span>{' '}
                    <span className="font-medium" data-id="element-1906" data-mp="1ypbj91detltp">
                      {formData.email || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1907" data-mp="28nivx80o1hpw">
                    <span className="text-gray-600" data-id="element-1908" data-mp="28o0sk5r8pxyc">Authorized Person:</span>{' '}
                    <span className="font-medium" data-id="element-1909" data-mp="23n4n3nr8q3qt">
                      {formData.authName || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1910" data-mp="3f29sizirage4">
                <div className="flex items-center justify-between mb-3" data-id="element-1911" data-mp="3mmu5oskpjmua">
                  <h4 className="font-semibold text-gray-900" data-id="element-1912" data-mp="3mlj3gx6wun5a">Bank Details</h4>
                  <button onClick={() => setCurrentStep(2)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1913" data-mp="3rmqcezkshsdj">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1914" data-mp="97xrjecq77fa">
                  <div data-id="element-1915" data-mp="98ppgvtsph8q">
                    <span className="text-gray-600" data-id="element-1916" data-mp="9aaa9tqb5lte">Bank Name:</span>{' '}
                    <span className="font-medium" data-id="element-1917" data-mp="e6925rauhlyk">
                      {formData.bankName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1918" data-mp="4gfq6p6sj4ts">
                    <span className="text-gray-600" data-id="element-1919" data-mp="4fo7geyal1kx">Account No:</span>{' '}
                    <span className="font-medium" data-id="element-1920" data-mp="s6jsmt88syj7">
                      {formData.accountNumber || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}